import OrbitMap from "@/components/OrbitMap";

const PIN_COLOR = { ok: "#10b981", watch: "#f59e0b", crit: "#ef4444" };

export default function RegionMap({ stores = [], onStoreClick, height = 288 }) {
  const points = stores.map((s) => ({
    id: s.id || s.name, lat: s.lat, lng: s.lng, color: PIN_COLOR[s.status || "ok"], radius: s.renew_badge ? 9 : 7,
    popup: (
      <div style={{ fontFamily: "'Plus Jakarta Sans',sans-serif", minWidth: 180 }}>
        <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 4 }}>{s.name}</div>
        {s.address && <div style={{ fontSize: 11, color: "#64748b" }}>{s.address}</div>}
        {s.perf != null && <div style={{ fontSize: 11, fontWeight: 600, color: PIN_COLOR[s.status || "ok"] }}>Perf {(s.perf * 100).toFixed(0)}%</div>}
        {s.renew_badge && <div style={{ fontSize: 11, color: "#ef4444", fontWeight: 600 }}>Contrat {s.renew_badge} — renouvellement &lt; 6 mois</div>}
        {onStoreClick && <button onClick={() => onStoreClick(s)} style={{ marginTop: 6, fontSize: 11, color: "#2563eb", fontWeight: 600 }} data-testid={`map-store-link-${s.id}`}>Voir le détail →</button>}
      </div>
    ),
  }));
  return <OrbitMap points={points} height={height} testid="region-map" legend={<>
    <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-emerald-500" />Perf ≥100%</span>
    <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-amber-500" />80-100%</span>
    <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-rose-500" />&lt;80%</span>
  </>} />;
}
